module.exports = __webpack_public_path__ + "assets/img/help_image04-1.517b736e.png";